module.exports = __webpack_public_path__ + "static/img/BANNER.09cf5b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/BANNER.png
// module id = JBlH
// module chunks = 1